/**
 * Address API Client
 * Handles Philippine address data: Provinces, Cities, Barangays
 */

import apiClient from '@/lib/api-client'

export interface Province {
  id: number
  province_name: string
  region_name: string | null
}

export interface CityMunicipality {
  id: number
  city_municipality_name: string
  province_id: number
  is_city: boolean
}

export interface Barangay {
  id: number
  barangay_name: string
  city_municipality_id: number
}

export const addressesApi = {
  /**
   * Get all provinces ordered alphabetically
   */
  getProvinces: async (): Promise<Province[]> => {
    const response = await apiClient.get<Province[]>('/addresses/provinces')
    return response.data
  },

  /**
   * Get all cities/municipalities for a specific province
   */
  getCitiesByProvince: async (provinceId: number): Promise<CityMunicipality[]> => {
    const response = await apiClient.get<CityMunicipality[]>(
      `/addresses/provinces/${provinceId}/cities`
    )
    return response.data
  },

  /**
   * Get all barangays for a specific city/municipality
   */
  getBarangaysByCity: async (cityId: number): Promise<Barangay[]> => {
    const response = await apiClient.get<Barangay[]>(
      `/addresses/cities/${cityId}/barangays`
    )
    return response.data
  },
}
